const getKey = (obj, key) => {
  if (!obj) {
    return obj;
  }

  return obj && typeof obj.get === 'function' ? obj.get(key) : obj[key];
};

export default getKey;
